import { Box, Button, Heading, Text, VStack } from '@chakra-ui/react';

interface MixinitMultipacksNoticeProps {
  compact?: boolean;
  href?: string;
  title?: string;
  description?: string;
  buttonLabel?: string;
}

const MIXINIT_URL = 'https://www.mixinit.io';

export default function MixinitMultipacksNotice({
  compact = false,
  href = MIXINIT_URL,
  title = 'Multipacks have moved',
  description = 'To get multipacks of your favorite tracks from the Crooklyn Clan Vault, please visit Mixinit.',
  buttonLabel = 'Visit Mixinit',
}: MixinitMultipacksNoticeProps) {
  return (
    <Box
      border="1px solid #e6e6e6"
      borderRadius="10px"
      bg="#f8f8f8"
      p={compact ? '20px' : '32px'}
    >
      <VStack align="start" spacing={compact ? 3 : 4}>
        <Heading size={compact ? 'sm' : 'md'}>{title}</Heading>
        <Text fontSize={compact ? '14px' : '16px'}>
          {description}
        </Text>
        <Button
          as="a"
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          bg="#111"
          color="#fff"
          _hover={{ bg: '#222' }}
        >
          {buttonLabel}
        </Button>
      </VStack>
    </Box>
  );
}
